import { useEffect, useRef, useState } from "react";

import { StandaloneCouponsAPI } from "../providers/StandaloneCouponsAPI";
import { Drawer } from "../shared/components/Drawer";
import { Empty } from "../shared/components/Empty";
import { Loading } from "../shared/components/Loading";
import { Title } from "../shared/components/Title";
import { If } from "../shared/components/control-statements";
import { ForEach } from "../shared/components/control-statements/ForEach";
import { Icon } from "../shared/components/core/Icon";
import { BenefitArchivedCard } from "../shared/containers/beneficios/BenefitArchivedCard";
import { BenefitInfo } from "../shared/containers/beneficios/BenefitInfo";
import { BenefitQrCode } from "../shared/containers/beneficios/BenefitQrCode";
import { useIsInViewport } from "../shared/hooks/useIsInViewport";
import styles from "../styles/beneficios/BenefitList.module.scss";

export default function BeneficiosArquivados() {
  const [benefits, setBenefits] = useState([]);
  const [hasNext, setHasNext] = useState(true);
  const [page, setPage] = useState(0);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [openQrCode, setOpenQrCode] = useState(false);

  const loadingRef = useRef(null);
  const isVisible = useIsInViewport(loadingRef);

  const selectedBenefitName = [selectedBenefit?.code, selectedBenefit?.pin].filter(Boolean).join(' - ');

  const loadBenefits = async () => {
    const response = await StandaloneCouponsAPI.getStandaloneCoupons(
      "ARCHIVED",
      null,
      page
    );
    const benefitsPage = response.getData({
      items: [],
      next: { page: -1, limit: 18 },
    });

    const newBenefitsPage = [...benefits, ...benefitsPage.items];

    setBenefits(newBenefitsPage);
    setHasNext(benefitsPage.next.page != -1);
    setPage(benefitsPage.next.page);
  };

  useEffect(() => {
    if (hasNext && isVisible) {
      loadBenefits();
    }
  }, [isVisible, page]);

  return (
    <>
      <Title
        title="Benefícios arquivados"
        backTo={{ url: "/beneficios", name: "Benefícios" }}
      />

      <div className={styles["benefits-list"]}>
        <ForEach
          items={benefits}
          render={(i) => (
            <BenefitArchivedCard
              benefit={i}
              onOpenQrCode={(e) => {
                setOpenQrCode(true);
                setSelectedBenefit(e);
              }}
              onOpenDetails={(e) => {
                setOpenDetails(true);
                setSelectedBenefit(e);
              }}
            />
          )}
        />
      </div>

      <If cond={hasNext}>
        <div className={styles.loading}>
          <Loading />
        </div>
        <div ref={loadingRef}></div>
      </If>

      <If cond={benefits.length == 0 && !hasNext}>
        <Empty>
          <Icon name="fa-ticket-simple" size="4x" />
          <p>Não há benefícios arquivados.</p>
        </Empty>
      </If>
      <BenefitQrCode
        benefit={selectedBenefit}
        visible={openQrCode}
        onClose={() => setOpenQrCode(false)}
      />
      <Drawer
        visible={openDetails}
        title="Informações do benefício"
        onClose={() => setOpenDetails(false)}
      >
        <BenefitInfo benefit={selectedBenefit} />
      </Drawer>
    </>
  );
}
